export async function get_form_url(name: string): Promise<{ submitAddr: string; name: string; formId: string }> {
  return {
    submitAddr: 'https://readdy.ai/api/form/d9rft6cnlsngrm4lmbmg',
    name: '开运体育联系表单',
    formId: 'd9rft6cnlsngrm4lmbmg',
  };
}